import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/inventory/items/";

export function getItems() {
  return http.get(apiEndpoint);
}

export function getItem(itemID) {
  return http.get(apiEndpoint + "item-detail/" + itemID);
}

export function deleteItem(itemID = 0) {
  return http.delete(apiEndpoint + "item/" + itemID);
}

export function restoreItem(itemID = 0) {
  return http.put(apiEndpoint + "item/" + itemID);
}

export function getItemUoms(itemID) {
  return http.get(apiEndpoint + "item-uoms/" + itemID);
}

export function getItemVariantDetail(itemID) {
  return http.get(apiEndpoint + "item-variant-detail/" + itemID);
}

export function getItemUnitConversion(altUomID) {
  return http.get(apiEndpoint + "item-unit-conversion/" + altUomID);
}

export function saveItem(item) {
  if (item.ID === 0) {
    return http.post(apiEndpoint, item);
  } else {
    return http.put(apiEndpoint, item);
  }
}

export function getItemsMasterData() {
  return http.get(apiEndpoint + "items-master-data");
}

export function getItemStocksLocation(
  itemID,
  varCode,
  warehouseID = 0,
  uomID = 0
) {
  return http.get(
    apiEndpoint +
      "item-stocks-location/" +
      itemID +
      "/" +
      varCode +
      "/" +
      warehouseID +
      "/" +
      uomID
  );
}
